import React from "react";
import { cn } from "../../utils/helpers";

export function Container({ children, className, size = "default", ...props }) {
  const sizeVariants = {
    sm: "max-w-4xl",
    default: "max-w-7xl",
    lg: "max-w-screen-2xl",
    full: "max-w-full",
  };

  return (
    <div
      className={cn(
        "w-full mx-auto px-4 sm:px-6 lg:px-8",
        sizeVariants[size],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
